import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackEvent } from 'helpers/analytics';
import { activeNetworkSelector } from 'redux/selectors';
import { useCreateFolderMutation } from 'services/listsTree';
import { contactsApi } from 'services/contacts';
import { toggleSection } from '../../../../features/mainMenu';

export const useListLinks = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.mainMenu.sections.lists);
  const { id: networkId } = useSelector(activeNetworkSelector);

  const [createFolder, { isLoading: creatingFolder }] = useCreateFolderMutation();
  const [openCreateFolder, setOpenCreateFolder] = useState(false);

  const handleToggleSection = useCallback(() => {
    dispatch(toggleSection('lists'));
  }, [dispatch]);

  const handleCreateListClick = useCallback(
    (event) => {
      if (event?.stopPropagation) event.stopPropagation();
      trackEvent('lists:create_list_click', {
        collectionId: networkId,
        page: 'lists',
        origin: 'sidebar',
      });
    },
    [networkId],
  );

  const openCreateFolderModal = useCallback((event) => {
    if (event?.stopPropagation) event.stopPropagation();
    setOpenCreateFolder(true);
  }, []);

  const handleCancelCreateFolder = useCallback(() => {
    setOpenCreateFolder(false);
  }, []);

  const handleSubmitCreateFolder = useCallback(
    async (name) => {
      const { error, data } = await createFolder({ name, networkId, parentId: null });
      if (!error) {
        trackEvent('lists:create_folder', {
          collectionId: networkId,
          folderId: data?.id,
          name,
          parentId: null,
          page: 'lists',
          origin: 'sidebar',
        });
        setOpenCreateFolder(false);
        dispatch(contactsApi.util.invalidateTags(['contacts-shared-lists']));
      }
      return { error, data };
    },
    [createFolder, networkId, dispatch],
  );

  return {
    isOpen,
    creatingFolder,
    openCreateFolder,
    handleToggleSection,
    handleCreateListClick,
    openCreateFolderModal,
    handleCancelCreateFolder,
    handleSubmitCreateFolder,
  };
};

export default useListLinks;
